import { Box, Grid } from '@mui/material';
import { PageHeading } from '../../../../shared/lib/common/PageHeading';
import palette from '../../../../shared/lib/theme/palette';
import { LABEL_BILLING } from '../../../../shared/lib/constants';
import { PaymentMethod } from './PaymentMethod';
import { PlanDetails } from './PlanDetails';
import { TransactionHistory } from './TransactionHistory';

export const BillingInvoice = () => {
  const { blackOne } = palette;

  return (
    <Box>
      <PageHeading title={LABEL_BILLING} color={blackOne} marginBottom="16px" />

      <Box mb="24px">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <PlanDetails />
          </Grid>

          <Grid item xs={12} md={6}>
            <PaymentMethod />
          </Grid>
        </Grid>
      </Box>

      <Box>
        <TransactionHistory />
      </Box>
    </Box>
  );
};
